import { TGiftOrDonation } from '@/lib/types';
import axiosInstance from '../lib/axios-instance';

export type TGetGiftCardsRes = {
  catalog: {
    catalogName: string;
    brands: {
      brandKey: string;
      brandName: string;
      disclaimer: string;
      description: string;
      shortDescription: string;
      terms: string;
      createdDate: string;
      lastUpdateDate: string;
      brandRequirements: {
        displayInstructions: string;
        termsAndConditionsInstructions: string;
        disclaimerInstructions: string;
        alwaysShowDisclaimer: boolean;
      };
      imageUrls: {
        '80w-326ppi': string;
        '130w-326ppi': string;
        '200w-326ppi': string;
        '278w-326ppi': string;
        '300w-326ppi': string;
        '1200w-326ppi': string;
      };
      status: string;
      items: {
        utid: string;
        rewardName: string;
        currencyCode: string;
        status: string;
        valueType: string;
        rewardType: string;
        isWholeAmountValueRequired: boolean;
        minValue: number;
        maxValue: number;
        createdDate: string;
        lastUpdateDate: string;
        countries: string[];
        credentialTypes: string[];
        redemptionInstructions: string;
        fulfillmentType: string;
      }[];
      categories: {
        identifier: string;
        description: string;
      }[];
    }[];
  }[];
};

export const getGiftCards = async ({
  type,
}: {
  type: TGiftOrDonation;
}): Promise<TGetGiftCardsRes> => {
  const url =
    type === 'giftcards'
      ? `/tango-giftcard-catalog`
      : `/tango-donation-catalog`;

  try {
    const res = await axiosInstance.get(url, {
      params: { tangoType: type },
    });

    return res.data;
  } catch (e) {
    console.error(e);
    throw new Error('Failed to get gift cards');
  }
};

export const claimTango = async ({
  type,
  utid,
  brandName,
}: {
  type: TGiftOrDonation;
  utid: string;
  brandName: string;
}) => {
  const urlByType = {
    giftcards: `add-tango-giftcard`,
    donations: `add-tango-donation`,
    digitalpayments: `add-digital-payment-${brandName}`,
  };

  try {
    const res = await axiosInstance.post(urlByType[type], {
      brandName,
      tangoType: type,
      utid,
    });

    return res.data;
  } catch (e) {
    console.error(e);
    throw new Error('Failed to claim gift card');
  }
};
